import { RouteConfig } from 'vue-router';

import ClubList from '@/views/club/List.vue';

export const clubsRoute: RouteConfig = {
  path: '',
  name: 'clubs',
  component: ClubList,
  meta: { authorized: true }
};
